<template>
  <div class="row">
    <wa-tabs />
    <div class="col-12">
      <div class="card">
        <div class="card-header wa-head">
          <h5 class="m-0"><i class="fa fa-archive"></i> أرشيف رسائل الواتساب</h5>
          <small class="text-muted">الرسائل التي أرسلها النظام عبر جهاز الواتساب المرتبط</small>
        </div>
        <div class="card-body">
          <div class="wa-filters">
            <div class="wa-search">
              <label for="wa-q" class="sr-only">بحث</label>
              <input id="wa-q" type="search" class="form-control" v-model="q" placeholder="ابحث برقم الجوال أو نص الرسالة أو التاريخ…" @keyup.enter="search()" />
            </div>
            <div>
              <label for="wa-status" class="sr-only">الحالة</label>
              <select id="wa-status" class="form-control" v-model="status" @change="search()">
                <option value="all">كل الحالات</option>
                <option value="1">تم الإرسال</option>
                <option value="2">فشل الإرسال</option>
                <option value="0">في انتظار الإرسال</option>
                <option value="3">إيقاف مؤقت</option>
                <option value="5">مجدولة</option>
                <option value="6">انتهت المهلة</option>
              </select>
            </div>
            <button class="btn btn-primary" @click="search()"><i class="fa fa-search"></i> بحث</button>
            <b-dropdown variant="outline-secondary" text="التحكم في الإرسال" class="wa-bulk" right>
              <b-dropdown-item @click="ask('pause')"><i class="fa fa-pause"></i> إيقاف مؤقت للرسائل الجارية</b-dropdown-item>
              <b-dropdown-item @click="ask('resume')"><i class="fa fa-play"></i> استكمال الرسائل المتوقفة</b-dropdown-item>
              <b-dropdown-item @click="ask('cancel')"><i class="fa fa-ban"></i> إلغاء كل الرسائل غير المرسلة</b-dropdown-item>
            </b-dropdown>
          </div>

          <div class="wa-confirm g" v-if="confirming">
            <p class="mb-1"><strong>{{ bulkText[confirming].q }}</strong></p>
            <p class="text-muted mb-1">{{ bulkText[confirming].hint }}</p>
            <button class="btn btn-sm" :class="confirming == 'cancel' ? 'btn-danger' : 'btn-primary'" :disabled="busy" @click="runBulk()">
              <i class="fa fa-check"></i> تأكيد
            </button>
            <button class="btn btn-sm btn-outline-secondary" :disabled="busy" @click="confirming = null">تراجع</button>
          </div>
          <div class="alert alert-success g" v-if="done">{{ done }}</div>
          <div class="alert alert-danger g" v-if="error">
            {{ error }}
            <router-link v-if="notLinked" to="/_whatsapp" class="wa-link">فحص الجهاز</router-link>
          </div>

          <div class="text-center g" v-if="loading">
            <img :src="require('@/assets/images/loading.svg')" style="width: 80px; height: 80px" alt="جاري التحميل" />
          </div>

          <div class="text-center text-muted g" v-if="!loading && !error && items.length == 0">
            <i class="fa fa-inbox wa-empty"></i>
            <p>لا توجد رسائل {{ q || status != 'all' ? 'مطابقة للبحث' : 'في الأرشيف بعد' }}</p>
          </div>

          <div class="table-responsive" v-if="!loading && items.length">
            <table class="table table-hover wa-table">
              <thead>
                <tr>
                  <th>الرقم</th>
                  <th>الرسالة</th>
                  <th>التاريخ</th>
                  <th>الحالة</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="m in items" :key="m._id">
                  <td class="wa-nowrap wa-to"><bdi dir="ltr">{{ m.to }}</bdi></td>
                  <td class="wa-msg">
                    <div :class="{ 'wa-clamp': !open[m._id] }">{{ m.message }}</div>
                    <button v-if="long(m.message)" class="btn btn-link btn-sm p-0" @click="toggle(m._id)">
                      {{ open[m._id] ? 'إخفاء' : 'عرض الرسالة كاملة' }}
                    </button>
                    <div v-if="m.file">
                      <a :href="m.file" target="_blank" rel="noopener"><i class="fa fa-paperclip"></i> عرض المرفق</a>
                    </div>
                  </td>
                  <td class="wa-nowrap wa-date"><bdi dir="ltr">{{ shortDate(m.date) }}</bdi></td>
                  <td>
                    <span :class="'wa-pill ' + pillOf(m.status)">{{ m.status_text }}</span>
                    <div class="wa-reason" v-if="m.reason">{{ m.reason }}</div>
                    <div class="wa-reason" v-if="m.schedule"><bdi dir="ltr">{{ shortDate(m.schedule) }}</bdi></div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="wa-pager" v-if="!loading && (page > 0 || hasMore)">
            <button class="btn btn-outline-primary btn-sm" :disabled="page == 0" @click="go(page - 1)">
              <i class="fa fa-arrow-right"></i> السابق
            </button>
            <span class="text-muted">صفحة {{ page + 1 }}</span>
            <button class="btn btn-outline-primary btn-sm" :disabled="!hasMore" @click="go(page + 1)">
              التالي <i class="fa fa-arrow-left"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue';
import WaTabs from './wa-tabs.vue';

export default {
  components: { WaTabs, BDropdown, BDropdownItem },
  data() {
    return {
      user: JSON.parse(localStorage.getItem('user')),
      items: [],
      q: '',
      status: 'all',
      page: 0,
      hasMore: false,
      loading: true,
      error: null,
      notLinked: false,
      open: {},
      confirming: null,
      busy: false,
      done: null,
      bulkText: {
        pause: { q: 'إيقاف الرسائل الجارية مؤقتاً؟', hint: 'تبقى في الأرشيف بحالة «إيقاف مؤقت» حتى تستكملها.', ok: 'تم إيقاف الرسائل الجارية مؤقتاً' },
        resume: { q: 'استكمال إرسال الرسائل المتوقفة؟', hint: 'تعود إلى قائمة الانتظار وتُرسل بالترتيب.', ok: 'تم استكمال الرسائل المتوقفة' },
        cancel: { q: 'إلغاء كل الرسائل التي لم تُرسل بعد؟', hint: 'يشمل الرسائل الجارية والمتوقفة والمجدولة، ولا يمكن التراجع عنه.', ok: 'تم إلغاء الرسائل غير المرسلة' },
      },
    };
  },
  created() {
    if (!checkPer('whatsapp')) {
      this.$router.push('/NotPermitted');
      return false;
    }
    this.load();
  },
  methods: {
    load() {
      var g = this;
      g.loading = true;
      $.post(api + '/user/whatsapp/archive', { jwt: g.user.jwt, status: g.status, q: g.q, page: g.page })
        .then(function (r) {
          g.loading = false;
          if (r.status != 100) {
            g.error = r.response;
            g.notLinked = !!r.not_linked;
            g.items = [];
            g.hasMore = false;
            return;
          }
          g.error = null;
          g.notLinked = false;
          g.items = r.response.items;
          g.hasMore = r.response.has_more;
          g.open = {};
        })
        .fail(function () {
          g.loading = false;
          g.error = 'تعذر الاتصال بالخادم، تحقق من الإنترنت';
        });
    },
    search() {
      this.page = 0;
      this.done = null;
      this.load();
    },
    go(p) {
      this.page = Math.max(0, p);
      this.load();
      window.scrollTo(0, 0);
    },
    toggle(id) {
      this.$set(this.open, id, !this.open[id]);
    },
    long(t) {
      return (t || '').length > 140 || (t || '').split('\n').length > 3;
    },
    ask(what) {
      this.done = null;
      this.confirming = what;
    },
    runBulk() {
      var g = this, what = g.confirming;
      g.busy = true;
      $.post(api + '/user/whatsapp/messages/status', { jwt: g.user.jwt, action: what })
        .then(function (r) {
          g.busy = false;
          g.confirming = null;
          if (r.status != 100) {
            g.error = r.response;
            return;
          }
          g.error = null;
          g.done = g.bulkText[what].ok;
          g.load();
        })
        .fail(function () {
          g.busy = false;
          g.confirming = null;
          g.error = 'تعذر الاتصال بالخادم، حاول مرة أخرى';
        });
    },
    pillOf(s) {
      return { 1: 'wa-pill-ok', 2: 'wa-pill-bad', 6: 'wa-pill-bad', 0: 'wa-pill-wait', 3: 'wa-pill-wait', 5: 'wa-pill-info' }[s] || 'wa-pill-wait';
    },
    shortDate(d) {
      return (d || '').toString().replace('T', ' ').split('.')[0].slice(0, 16);
    },
  },
};
</script>

<style scoped>
.wa-head {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}
.wa-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
.wa-search {
  flex: 1 1 260px;
}
.wa-confirm {
  border: 1px solid rgba(29, 78, 216, 0.3);
  border-radius: 10px;
  padding: 12px;
  margin-top: 12px;
}
.wa-confirm .btn {
  margin-top: 6px;
  margin-inline-end: 6px;
}
.wa-empty {
  font-size: 44px;
  opacity: 0.5;
}
.wa-table {
  margin-top: 12px;
  min-width: 640px;
}
.wa-table th {
  white-space: nowrap;
}
.wa-nowrap {
  white-space: nowrap;
}
.wa-msg {
  max-width: 460px;
  white-space: pre-line;
  overflow-wrap: anywhere;
}
.wa-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.wa-pill {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 12.5px;
  font-weight: 600;
  white-space: nowrap;
}
.wa-pill-ok {
  background: rgba(18, 183, 106, 0.14);
  color: #067647;
}
.wa-pill-wait {
  background: rgba(247, 144, 9, 0.16);
  color: #b54708;
}
.wa-pill-bad {
  background: rgba(240, 68, 56, 0.14);
  color: #b42318;
}
.wa-pill-info {
  background: rgba(122, 90, 248, 0.14);
  color: #5925dc;
}
.wa-reason {
  font-size: 12px;
  color: #6b7280;
  margin-top: 4px;
  max-width: 220px;
}
.wa-link {
  margin-inline-start: 8px;
  font-weight: 600;
}
/* phones: one stacked block per message instead of a wide table */
@media (max-width: 576px) {
  .wa-table {
    min-width: 0;
  }
  .wa-table thead {
    display: none;
  }
  .wa-table tbody,
  .wa-table tr,
  .wa-table td {
    display: block;
    width: 100%;
  }
  .wa-table tr {
    padding: 10px 0;
    border-bottom: 1px solid rgba(107, 114, 128, 0.2);
  }
  .wa-table td {
    border: 0;
    padding: 2px 0;
  }
  .wa-table .wa-to {
    font-weight: 700;
  }
  .wa-table .wa-date {
    font-size: 12px;
    color: #6b7280;
  }
  .wa-msg {
    max-width: none;
  }
}
.wa-pager {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 12px;
}
</style>
